import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

export default function FinishTreatmentModal({ open, onClose, onConfirm, treatmentDescription }) {
  const [finishDate, setFinishDate] = useState(dayjs());

  useEffect(() => {
    if (open) {
      setFinishDate(dayjs());
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="finish-dialog-title"
      aria-describedby="finish-dialog-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="finish-dialog-title">
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Concluir tratamento
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="finish-dialog-description" sx={{ mb: 2 }}>
          {treatmentDescription
            ? `O tratamento "${treatmentDescription}" será marcado como concluído.`
            : 'O tratamento será marcado como concluído.'}
        </DialogContentText>
        <DatePicker
          label="Data de Conclusão"
          value={finishDate}
          onChange={(date) => setFinishDate(date)}
          format="DD/MM/YYYY"
          slotProps={{ textField: { fullWidth: true } }}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={() => onConfirm(dayjs(finishDate).format('DD/MM/YYYY'))}
          variant="contained"
          color="primary"
          disabled={!finishDate || !dayjs(finishDate).isValid()}
        >
          Concluir
        </Button>
      </DialogActions>
    </Dialog>
  );
}

FinishTreatmentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  treatmentDescription: PropTypes.string,
};

FinishTreatmentModal.defaultProps = {
  treatmentDescription: '',
};
